if (!customElements.get('background-variable-trigger')) {
  customElements.define(
    'background-variable-trigger',
    class BackgroundVariableTrigger extends HTMLElement {
      constructor() {
        super();
        this.updateBackground = this.updateBackground.bind(this);
      }

      connectedCallback() {
        this.section = this.closest('.index-hero');
        if (!this.section) return;

        this.bgImage = this.getAttribute('data-bg-variable');
        this.bgImageMobile = this.getAttribute('data-bg-variable-mobile');

        if (this.bgImage || this.bgImageMobile) {
          this.preloadImages();
          this.addEventListener('mouseover', this.updateBackground);
          this.addEventListener('click', this.updateBackground);
        }
      }

      preloadImages() {
        const extractUrl = (str) => {
          if (!str) return null;
          const match = str.match(/url\(['"]?(.*?)['"]?\)/);
          return match ? match[1] : null;
        };

        const desktopUrl = extractUrl(this.bgImage);
        const mobileUrl = extractUrl(this.bgImageMobile);

        if (desktopUrl) {
          const img = new Image();
          img.src = desktopUrl;
        }

        if (mobileUrl) {
          const imgMobile = new Image();
          imgMobile.src = mobileUrl;
        }
      }

      updateBackground() {
        if (this.bgImage) {
          const currentBgImage = this.section.style.getPropertyValue('--bg-image');
          if (currentBgImage !== this.bgImage) {
            this.section.style.setProperty('--bg-image', this.bgImage);
          }
        }
        if (this.bgImageMobile) {
          const currentBgImageMobile = this.section.style.getPropertyValue('--bg-image-mobile');
          if (currentBgImageMobile !== this.bgImageMobile) {
            this.section.style.setProperty('--bg-image-mobile', this.bgImageMobile);
          }
        }
      }
    }
  );
}
